export default __webpack_public_path__ + "static/media/delete.fb518c9c.svg";